import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Spinner } from "../components/ui/Spinner";

/**
 * Erzwingt Login. Optional zusätzlich eine Berechtigung ("requirePermission")
 * oder den Systemadministrator-Status ("requireSuperAdmin" - unabhängig vom
 * normalen Rechtesystem, siehe pages/systemAdmin/DasEnde.tsx).
 */
export function ProtectedRoute({
  children,
  requirePermission,
  requireSuperAdmin,
}: {
  children: ReactNode;
  requirePermission?: string;
  requireSuperAdmin?: boolean;
}) {
  const { user, loading, hasPermission } = useAuth();

  if (loading) return <Spinner />;
  if (!user) return <Navigate to="/login" replace />;
  if (requireSuperAdmin && !user.isSuperAdmin) {
    return (
      <div className="flex flex-col items-center justify-center h-full text-center gap-2 py-20">
        <div className="text-4xl">🔒</div>
        <h2 className="text-lg font-semibold text-gray-200">Kein Zugriff</h2>
        <p className="text-sm text-gray-500">Diese Seite ist ausschließlich dem Systemadministrator vorbehalten.</p>
      </div>
    );
  }
  if (requirePermission && !hasPermission(requirePermission)) {
    return (
      <div className="flex flex-col items-center justify-center h-full text-center gap-2 py-20">
        <div className="text-4xl">🔒</div>
        <h2 className="text-lg font-semibold text-gray-200">Kein Zugriff</h2>
        <p className="text-sm text-gray-500">Ihnen fehlt die Berechtigung "{requirePermission}" für diese Seite.</p>
      </div>
    );
  }

  return <>{children}</>;
}
